"use client";

import { useEffect, useRef } from "react";

// Fires a one-time, throttled view event when a reader loads a blog post page.
// Mirrors how profile views are tracked (see ProfileDisplayCard).
export function BlogViewTracker({ slug }: { slug: string }) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!slug || firedRef.current) return;
    firedRef.current = true;
    try {
      fetch(`/api/blog/${encodeURIComponent(slug)}/view`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
        keepalive: true,
      }).catch(() => {});
    } catch {
      // Never let view tracking break the page
    }
  }, [slug]);

  return null;
}